import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ZODIAC_SIGNS } from '../data/zodiacSigns';
import { useAuth } from '../hooks/useAuth';

const CompatibilidadeEscolhaPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [slugA, setSlugA] = useState('');
  const [slugB, setSlugB] = useState('');

  const canSubmit = slugA && slugB;

  const handleSubmit = () => {
    if (!canSubmit) return;
    navigate(`/compatibilidade/${slugA}/${slugB}`);
  };

  return (
    <div className="min-h-screen bg-gradient-mystical">
      {!user && (
        <header className="border-b border-white/10 bg-black/20 backdrop-blur-sm">
          <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
            <Link to="/" className="text-white/60 hover:text-white transition-colors text-sm font-mystical tracking-widest uppercase">
              Astralyz
            </Link>
            <Link to="/register" className="text-xs px-4 py-2 rounded-full border border-white/20 text-white/70 hover:border-white/50 hover:text-white transition-all">
              Criar conta grátis
            </Link>
          </div>
        </header>
      )}

      <div className="max-w-md mx-auto px-4 py-14 text-center">
        <div className="text-5xl mb-4">💞</div>
        <h1 className="text-2xl sm:text-3xl font-mystical font-bold text-white mb-2">
          Compatibilidade entre Signos
        </h1>
        <p className="text-white/50 text-sm mb-10">
          Escolha os dois signos e veja família, amizade, sexo e amor — pronto pra compartilhar.
        </p>

        <div className="space-y-4 text-left mb-8">
          <div>
            <label className="block text-white/50 text-xs uppercase tracking-widest mb-2">Seu signo</label>
            <select
              value={slugA}
              onChange={e => setSlugA(e.target.value)}
              className="w-full rounded-xl px-4 py-3 text-white focus:outline-none"
              style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.2)' }}
            >
              <option value="" className="text-black">Selecione…</option>
              {ZODIAC_SIGNS.map(s => (
                <option key={s.slug} value={s.slug} className="text-black">{s.emoji} {s.name}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-white/50 text-xs uppercase tracking-widest mb-2">Signo da outra pessoa</label>
            <select
              value={slugB}
              onChange={e => setSlugB(e.target.value)}
              className="w-full rounded-xl px-4 py-3 text-white focus:outline-none"
              style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.2)' }}
            >
              <option value="" className="text-black">Selecione…</option>
              {ZODIAC_SIGNS.map(s => (
                <option key={s.slug} value={s.slug} className="text-black">{s.emoji} {s.name}</option>
              ))}
            </select>
          </div>
        </div>

        <button
          onClick={handleSubmit}
          disabled={!canSubmit}
          className="w-full py-3.5 rounded-2xl font-semibold text-white transition-opacity disabled:opacity-40 disabled:cursor-not-allowed hover:opacity-90"
          style={{ background: 'linear-gradient(135deg, #be185d, #f43f5e)' }}
        >
          Ver compatibilidade
        </button>
      </div>
    </div>
  );
};

export default CompatibilidadeEscolhaPage;
